import Service from "../../AuthService";

const ScanEmployee = {
    getScanEmployee(page) {
        return Service.get("/scan_employee?page=" + page);
    },
    showScanEmployee(id) {
        return Service.get("/scan_employee/" + id);
    },
    updateScanEmployee(id, data) {
        return Service.put("/scan_employee/" + id, data);
    },
    createScanEmployee(data) {
        return Service.post("/scan_employee", data);
    },
    deleteScanEmployee(id) {
        return Service.delete("/scan_employee/" + id);
    },
    searchScanEmployee(data) {
        return Service.post("/scan_employee_search", data);
    },
    //import hour
    getImportOTHour(data) {
        return Service.get(`/import_ot_hour?page=${data.page}&date=${data.date}&employee_id=${data.employee_id}&active=${data.active}`);
    },
    showImportOTHour(id) {
        return Service.get(`/import_ot_hour/${id}`);
    },
    updateImportOTHour(id, data) {
        //console.log(`/import_ot_hour/${id}`,data);
        return Service.put(`/import_ot_hour/${id}`, data);
    },
    createImportOTHour(data) {
        return Service.post(`/import_ot_hour`, data);
    },
    deleteImportOTHour(id) {
        return Service.delete(`/import_ot_hour/${id}`);
    },
    //import hour double
    getImportOTHourDouble(data) {
        return Service.get(`/import_ot_hour_double?page=${data.page}&date=${data.date}&employee_id=${data.employee_id}&active=${data.active}`);
    },
    showImportOTHourDouble(id) {
        return Service.get(`/import_ot_hour_double/${id}`);
    },
    updateImportOTHourDouble(id, data) {
        return Service.put(`/import_ot_hour_double/${id}`, data);
    },
    createImportOTHourDouble(data) {
        return Service.post(`/import_ot_hour_double`, data);
    },
    deleteImportOTHourDouble(id) {
        return Service.delete(`/import_ot_hour_double/${id}`);
    },
    printScanEmployeePDF(data) {
        return Service.get(`/work-time-pdf?name=${data.name}&employee_id=${data.employee_id}&department_id=${data.department_id}&start_date=${data.start_date}&end_date=${data.end_date}&index=${data.index}&continue_pdf=${data.continue_pdf}&start_page=${data.start_page}`
        )
    }
};
export default ScanEmployee;
